export enum Roles {
  SupportAdmin = 'SupportAdmin',
  HildaUser = 'HildaUser',
  AdvisorAdmin = 'AdvisorAdmin',
  AdvisorRep = 'AdvisorRep',
  HildaUserVO = 'HildaUserVO'
}
